module.exports = __webpack_public_path__ + "static/img/21.7e39be4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/21.png
// module id = XjxS
// module chunks = 0